/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowAltRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M1.747 17.253v-10h9V2.026l11.506 10.227-11.506 10.226v-5.226zm2-2h9v2.772l6.494-5.772-6.494-5.773v2.773h-9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowAltRight as ArrowAltRight };
